import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import store from '../store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*' },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  HOME: '/assets/data/home.json',
  GLOBALDATA: '/assets/data/global.json',
  SERVICES: '/assets/data/services.json',
  CONTACT: '/assets/data/contact.json'
}

function url (path, ...segments) {
  let i = 0
  const { state } = store
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return uri
}

export default {
  install (Vue, options) {
    const $api = {
      getData() {
        return http.get(url(API.GLOBALDATA))
      },
      getHome() {
        return http.get(url(API.HOME))
      },
      getServices() {
        return http.get(url(API.SERVICES))
      },
      getContact() {
        return http.get(url(API.CONTACT))
      }
    }

    Vue.prototype.$api = $api
    Vue.$api = $api
  }
}
